import type { PCPPage } from '@/constants/pcp/types';
import type { PCPUserData } from '../constants/types';

export const initialTestingPage: PCPPage = 'pre_nurse';

export const initialTestingUserData: PCPUserData = {
  journeyCompleted: false,
  prefillFormData: {
    token: 'testing',
    email: 'testing@example.com',
  },
  preNurseConsultation: {
    completed: false,
    consultationBooked: true,
    calcomBookingUrl: 'https://bookings.staging.alternaleaf.com.au/team/alternaleaf-nurses/initial-consultation',
    preConsultationForm: {
      required: true,
      completed: false,
    },
    concessionCardDetailsForm: {
      required: false,
      completed: false,
    },
  },
  preDoctorConsultation: {
    completed: false,
    consultationBooked: true,
    calcomBookingUrl:
      'https://bookings.staging.alternaleaf.com.au/team/alternaleaf-doctors/medical-cannabis-consultation',
    dassForm: {
      required: true,
      completed: false,
      formUrl: 'https://pms.staging.alternaleaf.com.au/dass/1234/abcdefg-12...',
    },
  },
};
